// src/components/PopSidebar/PopSidebar.jsx
import React, { useState } from "react";
import { IoMdArrowBack } from "react-icons/io"; // Back arrow
import { FaRegUserCircle } from "react-icons/fa"; // My Profile icon
import { RiLockPasswordLine } from "react-icons/ri"; // Password Reset icon
import { FiLogOut } from "react-icons/fi"; // Logout icon

import { put as puts } from "../../utility/fetchWeb"; // Assuming you have a utility function for PUT requests

import UserAvater from "../../assets/images/user-avater.png"; // Your default avatar image
import ForgotPasswordModal from "./ForgotPasswordModal";
import { useNavigate } from "react-router-dom";
import UploadButton from "./UploadButton";
import notification from "../../utility/notification";

// import "./PopSidebar.css"; // We'll create this CSS file next

const PopSidebar = ({ isOpen, onClose, userInfo }) => {

    const [isForgotModalOpen, setIsForgotModalOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // For Header/Sidebar demo
  const [profilePicture, setProfilePicture] = useState(sessionStorage.getItem('profilePicture') || UserAvater);


  const navigate = useNavigate();

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleOpenForgotModal = (e) => {
    e.stopPropagation();
    setIsForgotModalOpen(true);
  };

  const handleCloseForgotModal = () => {
    setIsForgotModalOpen(false);
  };
  // Function to handle image errors for the larger sidebar avatar
  const handleSidebarImgError = (e) => {
    e.target.src = UserAvater; // Fallback to default user avatar
  };

  if (!isOpen) {
    return null; // Don't render if not open to save resources
  }

  return (
    <>
      {/* Overlay/Backdrop to close sidebar when clicking outside */}
      <div className="sidebar-overlay" onClick={onClose}></div>

      <div className="sidebar-container">
        <div className="sidebar-header">
          <IoMdArrowBack className="back-arrow" onClick={onClose} />
          {/* Top right icon, similar to the main header's user icon */}
          {/* <div className="sidebar-header-user-icon">
            <FaRegUserCircle />
          </div> */}
        </div>

        <div className="sidebar-profile-section">
          <div className="sidebar-avatar-wrapper">
            <img
              src={profilePicture || UserAvater} // Use actual profile pic if available, otherwise default
              alt="User Avatar"
              className="sidebar-main-avatar"
              onError={handleSidebarImgError}
            />
            
          </div>
          <UploadButton
                  buttonText={'Upload Photo'} // Optional: use camera icon for clarity
                  acceptedFiles="image/*"
                  onUploadSuccess={async (response) => {
                    if (response?.doclink) {
                      setProfilePicture(response?.doclink);
                      sessionStorage.setItem('profilePicture', response?.doclink);
                      const updateRes = await puts(`/Patient/photo-update-employee`, {
                        pictureUrl: response.doclink,
                        employeeId: Number(sessionStorage.getItem('userId'))
                      });
                    }
                  }}
                  onUploadError={(error) => {
                    notification({
                      type: 'error',
                      message: 'Failed to update profile photo'
                    });
                  }}
                />
          {/* <button className="upload-photo-btn">UPLOAD PHOTO</button> */}

          <h2 className="sidebar-username">
            {userInfo?.firstName} {userInfo?.lastName}
          </h2>
          <p className="sidebar-status-dot"></p> {/* Status dot */}
        </div>

        <ul className="sidebar-menu">
          <li className="sidebar-menu-item" onClick={() => {
            console.log("Navigating to My Profile");
            navigate("/profile")
            onClose(); // Close sidebar
            // Add navigation logic here, e.g., history.push('/profile');
          }}>
            <FaRegUserCircle className="menu-icon" />
            <div className="menu-text">
              <h3>My Profile</h3>
              <p>View and edit your profile</p>
            </div>
          </li>

          <li className="sidebar-menu-item" onClick={(e) => {
            console.log("Navigating to Password Reset");
            handleOpenForgotModal(e);
            // onClose(); // Close sidebar
            // Add navigation logic here, e.g., history.push('/reset-password');
          }}>
            <RiLockPasswordLine className="menu-icon" />
            <div className="menu-text">
              <h3>Password Reset</h3>
              <p >Change your password</p>
            </div>
          </li>

          <li className="sidebar-menu-item logout-item" onClick={() => {
            console.log("Logging out...");
            // Implement your logout logic here:
            localStorage.removeItem('USER_INFO');
            sessionStorage.removeItem('healthCareProviderName');
            localStorage.clear();
            sessionStorage.clear();
            onClose(); // Close sidebar
            // Redirect to login page
            // if (history) history.push('/login'); // If you pass history prop
            window.location.href = '/'; // A simple redirect if no history object is available
          }}>
            <FiLogOut className="menu-icon logout-icon" />
            <div className="menu-text">
              <h3>Logout</h3>
              <p>Sign out of your account</p>
            </div>
          </li>
        </ul>
      </div>
      <ForgotPasswordModal
        isOpen={isForgotModalOpen}
        onClose={handleCloseForgotModal}
        closeSideBar={onClose}
      />
    </>
  );
};

export default PopSidebar;